import { render, staticRenderFns } from "./SlotRoom.vue?vue&type=template&id=0a1562c5&scoped=true&"
import script from "./SlotRoom.vue?vue&type=script&lang=js&"
export * from "./SlotRoom.vue?vue&type=script&lang=js&"
import style0 from "./SlotRoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1562c5",
  null
  
)

export default component.exports